export const getParentCategories = categories => {
  return categories.filter(category => category.parent_categories.includes("category:UI_New_2020"));
};

export const getSubCategories = (categories, parentCategoryId) => {
  return categories.filter(({ parent_categories }) => parent_categories.includes(parentCategoryId));
};

export const getTopicsByCategoryId = (topics, categoryId) => {
  return topics.filter(({ categories }) => categories.includes(categoryId));
};

export const getTopicById = (topics, topicId) => {
  const currentTopic = topics.filter(({ id }) => id === topicId);
  return currentTopic[0];
};

export const getCategoryById = (categories, categoryId) => {
  const category = categories.filter(({ id }) => id === categoryId);
  return category[0];
};
